import {Component, inject, OnInit} from "@angular/core";
import {DateUtils, ErrorWrapper, ErrorWrapperFactory, NewsEntriesList, NewsService} from "@kwsoft/otcx-core";
import {DateTime} from "luxon";

@Component({
    selector: "otcx-home-news",
    templateUrl: "./home-news.component.html",
    standalone: false
})
export class HomeNewsComponent implements OnInit {
    newsLoader: ErrorWrapper<NewsEntriesList>;

    private readonly newsService = inject(NewsService);
    private readonly errorWrapperFactory = inject(ErrorWrapperFactory<NewsEntriesList>);

    ngOnInit(): void {
        const twoWeeksAgo = DateUtils.toApiDate(DateTime.local().minus({days: 14}));
        this.newsLoader = this.errorWrapperFactory.wrap(this.newsService.getNewsEntries(twoWeeksAgo));
    }
}
